/**
 * Created by Daniela on 23/01/2017.
 */
import { Component, OnInit } from '@angular/core';

import { abastecimentoBensModuleName, abastecimentoBensRoute } from "../../abastecimento-bens/shared/data.service";
import { bombasRoute, bombasAuditoriaRoute, bombasAuditoriaModuleName } from "../../bombas/shared/data.service";
import { abastecimentosRoute } from "../data.service";
import { tanquesRoute, tanquesEstoqueRoute, tanquesEstoqueModuleName } from "../../tanques/shared/data.service";

@Component({
    selector: 'app-abastecimento-menu',
    template: require('./abastecimento-menu.component.html')
})
export class AbastecimentoMenuComponent implements OnInit {
    abastecimentosRoute: string = abastecimentosRoute;
    abastecimentoBensRoute: string = abastecimentoBensRoute;
    abastecimentoBensModule: any = abastecimentoBensModuleName;
    bombasRoute: string = bombasRoute;
    tanquesRoute: string = tanquesRoute;
    tanquesEstoqueRoute: string = tanquesEstoqueRoute;
    tanquesEstoqueModuleName: string = tanquesEstoqueModuleName;
    bombasAuditoriaRoute: string = bombasAuditoriaRoute;
    bombasAuditoriaModuleName: string = bombasAuditoriaModuleName;

    constructor() { }

    ngOnInit() {
    }
}



/** WEBPACK FOOTER **
 ** ./~/angular2-template-loader!./src/app/abastecimentos/shared/abastecimento-menu/abastecimento-menu.component.ts
 **/